// MATERIAL DESIGN ICONS MAPPED TO MIME TYPE

export default {
	'text/pdf': 'mdi-file-pdf',
	'text/csv': 'mdi-file-delimited',
	'text/plain': 'mdi-file-document',
	'application/msword': 'mdi-file-word',
	'image/png': 'mdi-file-image',
	'image/jpg': 'mdi-file-image',
	'default': 'mdi-file'
}